import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, DollarSign } from 'lucide-react';
import AdminLayout from '../../../components/admin/AdminLayout';

const ProfitabilityReportsPage = () => {
  const navigate = useNavigate();
  const [groupBy, setGroupBy] = useState('client');

  const profitabilityData = [
    { name: 'محمد أحمد', revenue: 25000, expenses: 8000, profit: 17000 },
    { name: 'شركة النور', revenue: 45000, expenses: 15000, profit: 30000 }
  ];

  return (
    <AdminLayout>
      <div className="p-6 max-w-7xl mx-auto">
        <button onClick={() => navigate('/admin/finance/reports')} className="inline-flex items-center gap-2 text-gray-600 hover:text-[#1E3A8A] mb-4 transition-colors">
          <ArrowRight className="w-5 h-5" /><span className="font-semibold">العودة للتقارير</span>
        </button>
        <h1 className="text-3xl font-black text-[#1E3A8A] mb-6 flex items-center gap-3">
          <DollarSign className="w-8 h-8" /><span>تقارير الربحية</span>
        </h1>

        <div className="bg-white rounded-lg shadow-sm border-2 border-gray-200 p-4 mb-6">
          <label className="block text-sm font-bold text-gray-700 mb-2">تجميع حسب</label>
          <select value={groupBy} onChange={(e) => setGroupBy(e.target.value)} className="w-full px-4 py-2 border-2 border-gray-200 rounded-lg focus:border-[#1E3A8A] focus:outline-none">
            <option value="client">العميل</option>
            <option value="case">القضية</option>
            <option value="service">نوع الخدمة</option>
          </select>
        </div>

        <div className="bg-white rounded-lg shadow-sm border-2 border-gray-200 overflow-hidden">
          <table className="w-full">
            <thead className="bg-gray-50 border-b-2 border-gray-200">
              <tr>
                <th className="px-4 py-3 text-right text-sm font-bold text-gray-700">الاسم</th>
                <th className="px-4 py-3 text-right text-sm font-bold text-gray-700">الإيرادات</th>
                <th className="px-4 py-3 text-right text-sm font-bold text-gray-700">المصروفات</th>
                <th className="px-4 py-3 text-right text-sm font-bold text-gray-700">الربح</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {profitabilityData.map((d, i) => (
                <tr key={i} className="hover:bg-gray-50">
                  <td className="px-4 py-3 font-semibold">{d.name}</td>
                  <td className="px-4 py-3 text-green-600 font-bold">{d.revenue.toLocaleString()} ر.س</td>
                  <td className="px-4 py-3 text-red-600 font-bold">{d.expenses.toLocaleString()} ر.س</td>
                  <td className="px-4 py-3 text-[#1E3A8A] font-black text-lg">{d.profit.toLocaleString()} ر.س</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
};

export default ProfitabilityReportsPage;